import { CLASSNAME } from '~/assistant/utils/constants';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  target: HTMLElement;
  onClick?: () => void;
  [key: string]: any;
};

class Button {
  props: Props;

  constructor(props: Props) {
    this.props = { ...props };
    this.render();
  }

  template() {
    return `
      <button class="${bem([
        CLASSNAME,
        'chat',
        'go-button',
      ])}">${this.props.buttonText}</button>
    `;
  }

  render() {
    const { target } = this.props;
    target.insertAdjacentHTML('beforeend', this.template());
    this.setEvent();
  }

  setEvent() {
    const { onClick = () => {} } = this.props;
    const button = document.querySelector(
      `.${bem([CLASSNAME, 'chat', 'go-button'])}`
    );

    button?.addEventListener('click', () => {
      onClick();
    });
  }
}

export default Button;
